// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.105.2/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.105.2/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Ajustar el contenido interno del modal para Sticky Header */
.p-dialog .p-dialog-content {
  padding: 1rem !important;
  display: flex;
  flex-direction: column;
  height: 100%;
  overflow: hidden; /* Evita que el scroll sea global */
}

/* Si quieres también reducir el espacio exterior del modal */
.p-dialog {
  margin: 0 auto;
  width: 95vw !important; /* Más ancho */
  height: 90vh !important; /* Altura fija para permitir scroll interno */
  max-height: 90vh;
}

/*hace que el resumen quede al lado derecho*/
.contenedor-flex {
  display: flex;
  gap: 0 rem; /* Sin gap extra si usamos anchos porcentuales */
  align-items: center; /* Alineación vertical centrada */
  flex-wrap: nowrap; /* 🔥 Forzar una sola línea */
}

/*ESTILOS PARA DASHBOARD*/
/* (Migrados a DashboardContenedor.css) */
.dashboard-contenedor-flex {
  /* Se mantiene solo lo estructural del layout del modal si fuera necesario, 
     pero idealmente el componente ya trae su propio display: flex.
     Dejamos flex: 1 para que ocupe espacio en el modal padre. */
  flex: 1 1;
}

/* Elimina también los márgenes de los divs si hace falta */
.dashboard-contenedor div {
  margin: 0;
  padding: 0;
}

.dashboard-contenedor-flex,
.dashboard-general,
.dashboard-stats,
.dashboard-general h4,
.dashboard-general p,
.dashboard-general div {
  margin: 0 !important;
  padding: 0 !important;
}

/* 🔹 Reduce el alto de las filas y el padding de las celdas */
.p-datatable-tbody > tr > td,
.p-datatable-thead > tr > th {
  padding: 0rem 0.5rem; /* Ajusta a tu gusto */
  line-height: 1.2; /* Ajusta la altura del texto */
}
`, "",{"version":3,"sources":["webpack://./src/styles/cssAsociarPedCtnModal.css"],"names":[],"mappings":"AAAA,8DAA8D;AAC9D;EACE,wBAAwB;EACxB,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,gBAAgB,EAAE,mCAAmC;AACvD;;AAEA,6DAA6D;AAC7D;EACE,cAAc;EACd,sBAAsB,EAAE,cAAc;EACtC,uBAAuB,EAAE,6CAA6C;EACtE,gBAAgB;AAClB;;AAEA,4CAA4C;AAC5C;EACE,aAAa;EACb,UAAU,EAAE,gDAAgD;EAC5D,mBAAmB,EAAE,iCAAiC;EACtD,iBAAiB,EAAE,6BAA6B;AAClD;;AAEA,yBAAyB;AACzB,yCAAyC;AACzC;EACE;;gEAE8D;EAC9D,SAAO;AACT;;AAEA,2DAA2D;AAC3D;EACE,SAAS;EACT,UAAU;AACZ;;AAEA;;;;;;EAME,oBAAoB;EACpB,qBAAqB;AACvB;;AAEA,8DAA8D;AAC9D;;EAEE,oBAAoB,EAAE,sBAAsB;EAC5C,gBAAgB,EAAE,+BAA+B;AACnD","sourcesContent":["/* Ajustar el contenido interno del modal para Sticky Header */\n.p-dialog .p-dialog-content {\n  padding: 1rem !important;\n  display: flex;\n  flex-direction: column;\n  height: 100%;\n  overflow: hidden; /* Evita que el scroll sea global */\n}\n\n/* Si quieres también reducir el espacio exterior del modal */\n.p-dialog {\n  margin: 0 auto;\n  width: 95vw !important; /* Más ancho */\n  height: 90vh !important; /* Altura fija para permitir scroll interno */\n  max-height: 90vh;\n}\n\n/*hace que el resumen quede al lado derecho*/\n.contenedor-flex {\n  display: flex;\n  gap: 0 rem; /* Sin gap extra si usamos anchos porcentuales */\n  align-items: center; /* Alineación vertical centrada */\n  flex-wrap: nowrap; /* 🔥 Forzar una sola línea */\n}\n\n/*ESTILOS PARA DASHBOARD*/\n/* (Migrados a DashboardContenedor.css) */\n.dashboard-contenedor-flex {\n  /* Se mantiene solo lo estructural del layout del modal si fuera necesario, \n     pero idealmente el componente ya trae su propio display: flex.\n     Dejamos flex: 1 para que ocupe espacio en el modal padre. */\n  flex: 1;\n}\n\n/* Elimina también los márgenes de los divs si hace falta */\n.dashboard-contenedor div {\n  margin: 0;\n  padding: 0;\n}\n\n.dashboard-contenedor-flex,\n.dashboard-general,\n.dashboard-stats,\n.dashboard-general h4,\n.dashboard-general p,\n.dashboard-general div {\n  margin: 0 !important;\n  padding: 0 !important;\n}\n\n/* 🔹 Reduce el alto de las filas y el padding de las celdas */\n.p-datatable-tbody > tr > td,\n.p-datatable-thead > tr > th {\n  padding: 0rem 0.5rem; /* Ajusta a tu gusto */\n  line-height: 1.2; /* Ajusta la altura del texto */\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
